<template>
  <div
    class="employee-fragment"
    :class="{
      '-inline': inline,
    }"
  >
    <h4>
      {{ employee.name }}
    </h4>
    <p v-if="showNumber">
      {{ employee.id }}
    </p>
    <p>
      {{ employee.jobTitle }}
    </p>
  </div>
</template>

<script setup>
defineProps({
  employee: {
    type: Object,
    default: null,
  },
  inline: {
    type: Boolean,
  },
  showNumber: {
    type: Boolean,
  },
});
</script>

<style>
.employee-fragment {
  &.-inline {
    display: flex;
    gap: 4px;
  }
}
</style>
